import {useState, useEffect, useCallback, useRef} from 'react';

import {useResizeObserver} from 'hooks/useResizeObserver/useResizeObserver';

/**
 * Custom hook for use sidebar as sticky from bottom when sidebars are wider than screen
 */
const useStickySidebar = (sidebarEl: HTMLElement | null) => {
    const sideBarGap = '50px';
    const [stickyElementHeight, setStickyElementHeight] = useState<number>(0);
    const [screenHeight, setScreenHeight] = useState<number>(0);
    const timeout = useRef<number>();

    const updateHeights = useCallback(() => {
        if (sidebarEl?.offsetHeight) {
            setScreenHeight(window.innerHeight);
            setStickyElementHeight(sidebarEl.offsetHeight);
        }
    }, [sidebarEl]);

    useResizeObserver(sidebarEl, updateHeights);

    useEffect(() => {
        const handleResize = () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
            }
            timeout.current = window.setTimeout(() => {
                updateHeights();
            }, 100);
        };

        // watch screen resize
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [updateHeights]);

    useEffect(() => {
        if (stickyElementHeight && sidebarEl) {
            if (stickyElementHeight > screenHeight) {
                sidebarEl.style.top = `${screenHeight - stickyElementHeight}px`;
            } else {
                sidebarEl.style.top = sideBarGap;
            }
        }
    }, [stickyElementHeight, screenHeight, sidebarEl]);
};

export default useStickySidebar;
